import { render, staticRenderFns } from "./ClientArea.vue?vue&type=template&id=89471972&"
import script from "./ClientArea.vue?vue&type=script&lang=js&"
export * from "./ClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientArea.vue"
export default component.exports